module.exports = __webpack_public_path__ + "img/title4.59442fb3.png";